
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenilirlik',
      description: 'Müşterilerimize güvenilir ve kaliteli hizmet sunmak en önemli önceliğimizdir.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Müşteri Memnuniyeti',
      description: 'Müşteri memnuniyetini her zaman ön planda tutarak hizmet veriyoruz.',
    },
    {
      icon: 'ri-team-line',
      title: 'Profesyonellik',
      description: 'Uzman ve deneyimli ekibimizle profesyonel çözümler üretiyoruz.',
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Yenilikçilik',
      description: 'Sektördeki yenilikleri takip ederek en güncel çözümleri sunuyoruz.',
    },
  ];

  const team = [
    {
      name: 'Ahmet Yılmaz',
      position: 'Genel Müdür',
      image: 'https://public.readdy.ai/ai/img_res/c038ed0260bb5551a5f4bac8e85e4aec.jpg',
    },
    {
      name: 'Mehmet Demir',
      position: 'Teknik Müdür',
      image: 'https://readdy.ai/api/search-image?query=professional%20turkish%20engineer%20in%20work%20uniform%20with%20safety%20equipment%20clean%20white%20background%20industrial%20portrait%20bright%20lighting&width=300&height=300&seq=team2&orientation=squarish',
    },
    {
      name: 'Ayşe Kaya',
      position: 'Müşteri İlişkileri Müdürü',
      image: 'https://readdy.ai/api/search-image?query=professional%20turkish%20business%20woman%20in%20formal%20attire%20smiling%20clean%20white%20background%20corporate%20portrait%20photography%20bright%20studio%20lighting&width=300&height=300&seq=team3&orientation=squarish',
    },
    {
      name: 'Fatih Özkan',
      position: 'Operasyon Müdürü',
      image: 'https://readdy.ai/api/search-image?query=professional%20turkish%20operations%20manager%20in%20business%20casual%20attire%20clean%20white%20background%20corporate%20portrait%20bright%20lighting&width=300&height=300&seq=team4&orientation=squarish',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-primary-600 to-primary-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <h1 className="font-display font-bold text-5xl md:text-6xl mb-6">
              Kurumsal
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Yangın güvenliği konusunda güvenilir çözüm ortağınız
            </p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-4xl text-dark-900 mb-8 text-center">
            Hakkımızda
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-dark-600 leading-relaxed mb-6">
              <strong>İpek Yangın Söndürme</strong>, yangın güvenliği alanında uzmanlaşmış, deneyimli ve güvenilir bir firmadır. Yangın söndürme tüpü satış, dolum, bakım hizmetlerinin yanı sıra baca temizliği, davlumbaz temizliği ve otomatik davlumbaz söndürme sistemi kurulum ve bakım hizmetleri sunmaktayız.
            </p>
            <p className="text-dark-600 leading-relaxed mb-6">
              Yılların verdiği deneyim ve bilgi birikimimizle, müşterilerimize en kaliteli hizmeti sunmayı hedefliyoruz. Profesyonel ekibimiz, modern ekipmanlarımız ve müşteri odaklı yaklaşımımızla yangın güvenliği konusunda güvenilir çözüm ortağınız olmaktan gurur duyuyoruz.
            </p>
            <p className="text-dark-600 leading-relaxed mb-6">
              Ev, işyeri, fabrika, restoran ve tüm ticari alanlar için yangın güvenliği çözümleri sunuyoruz. Hızlı servis, uygun fiyat ve kaliteli hizmet anlayışımızla müşteri memnuniyetini her zaman ön planda tutuyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-flag-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-bold text-3xl text-dark-900 mb-4">
                Misyonumuz
              </h3>
              <p className="text-dark-600 leading-relaxed">
                Yangın güvenliği konusunda en kaliteli hizmeti sunarak, müşterilerimizin can ve mal güvenliğini korumak. Profesyonel ekibimiz ve modern ekipmanlarımızla, yangın risklerini minimize ederek güvenli yaşam ve çalışma alanları oluşturmak.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="w-16 h-16 bg-primary-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-eye-line text-4xl text-primary-600"></i>
              </div>
              <h3 className="font-display font-bold text-3xl text-dark-900 mb-4">
                Vizyonumuz
              </h3>
              <p className="text-dark-600 leading-relaxed">
                Yangın güvenliği sektöründe lider bir firma olmak. Sürekli gelişim ve yenilikçi yaklaşımlarla, bölgemizde yangın güvenliği konusunda ilk tercih edilen, güvenilir ve saygın bir marka haline gelmek.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-4xl text-dark-900 mb-12 text-center">
            Değerlerimiz
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${value.icon} text-4xl text-primary-600`}></i>
                </div>
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-3">
                  {value.title}
                </h3>
                <p className="text-dark-600">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quality Section */}
      <section className="py-20 bg-dark-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-4xl text-dark-900 mb-8 text-center">
            Kalite Yaklaşımımız
          </h2>
          <div className="prose prose-lg max-w-none">
            <p className="text-dark-600 leading-relaxed mb-6">
              İpek Yangın Söndürme olarak, kalite bizim için vazgeçilmez bir önceliktir. Tüm hizmetlerimizde ve ürünlerimizde en yüksek kalite standartlarını uyguluyoruz.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white rounded-lg p-6 border-l-4 border-primary-600">
                <h4 className="font-semibold text-dark-900 mb-2">Sertifikalı Ürünler</h4>
                <p className="text-dark-600 text-sm">Tüm ürünlerimiz TSE standartlarına uygun ve sertifikalıdır</p>
              </div>
              <div className="bg-white rounded-lg p-6 border-l-4 border-primary-600">
                <h4 className="font-semibold text-dark-900 mb-2">Uzman Ekip</h4>
                <p className="text-dark-600 text-sm">Sertifikalı ve deneyimli teknisyenlerimiz</p>
              </div>
              <div className="bg-white rounded-lg p-6 border-l-4 border-primary-600">
                <h4 className="font-semibold text-dark-900 mb-2">Modern Ekipman</h4>
                <p className="text-dark-600 text-sm">En güncel teknoloji ve ekipmanlarla hizmet</p>
              </div>
              <div className="bg-white rounded-lg p-6 border-l-4 border-primary-600">
                <h4 className="font-semibold text-dark-900 mb-2">Düzenli Kontrol</h4>
                <p className="text-dark-600 text-sm">Periyodik kontrol ve uygunluk takibi</p>
              </div>
            </div>
            <p className="text-dark-600 leading-relaxed">
              Müşterilerimize sunduğumuz her hizmette, yasal düzenlemelere ve güvenlik standartlarına tam uyum sağlıyoruz. Periyodik kontroller ve uygunluk takibi ile hizmet kalitemizi sürekli iyileştiriyoruz.
            </p>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-display font-bold text-4xl text-dark-900 mb-12 text-center">
            Ekibimiz
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <div key={index} className="text-center">
                <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <h3 className="font-display font-semibold text-xl text-dark-900 mb-2">
                  {member.name}
                </h3>
                <p className="text-primary-600 font-medium">
                  {member.position}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-white mb-6">
            Bizimle Çalışmak İster misiniz?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Yangın güvenliği konusunda profesyonel çözümler için bizimle iletişime geçin
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="/iletisim" 
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-50 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              İletişime Geç
            </a>
            <a 
              href="tel:+905319619192" 
              className="bg-dark-900 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-dark-800 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
            >
              <i className="ri-phone-line"></i>
              <span>Hemen Ara</span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
